/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Typography, Divider, Button, Popover } from "@mui/material";
import React, { useState, useEffect, useRef, useCallback } from "react";
import qs from "query-string";
import LoadingSpinner from "../../components/Composables/CircularProgressBar";
import CountInfo from "../../components/Composables/TilesCountInfo";
import API from "../../Utils/Interceptor/ApiMiddleware";
import DynamicDataGrid from "../../components/Composables/DynamicDataGrid";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import formatters from "../../components/Composables/DataGridFormatters";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import DynamicForm from "../../components/Composables/DynamicForm";
import { debounce } from "lodash";
import AddUser from "./AddUser";
import { useNavigate, useLocation } from "react-router-dom";

function Users() {
  const [loading, setLoading] = useState({
    count: false,
    grid: false,
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const location = useLocation();
  const [usersData, setUsersData] = useState({
    countData: [],
    listData: [],
    paginationModel: {
      pageSize: 25,
      page: 0,
    },
  });
  const debounceTimeout = useRef(null);
  const latestInputValue = useRef("");
  const navigate = useNavigate();
  const [formState, setFormState] = useState({
    name: null,
    email: null,
    status: null,
    role: null,
    city: null,
  });
  const [appliedFilters, setAppliedFilters] = useState({
    name: null,
    email: null,
    status: null,
    role: null,
    city: null,
  });
  const [tempFormState, setTempFormState] = useState(formState);
  const [formConfigurations, setFormConfigurations] = useState([
    {
      label: "User Name",
      type: "autocomplete-multiple",
      name: "name",
      options: [],
      text: "User Name",
    },
    {
      label: "User Email",
      type: "autocomplete-multiple",
      name: "email",
      options: [],
      text: "User Email",
    },
    {
      label: "Status",
      type: "autocomplete-multiple",
      name: "status",
      text: "Status",
      options: [
        { value: "1", label: "Active" },
        { value: "2", label: "Paused" },
      ],
    },
    {
      label: "Role Name",
      type: "autocomplete-multiple",
      name: "role",
      options: [],
      text: "Role Name",
    },
    // {
    //   label: "City",
    //   type: "autocomplete-multiple",
    //   name: "city",
    //   options: [],
    //   text: "City",
    // },
  ]);

  const [addUserDialog, setAddUserDialog] = useState(false);
  const handleChange = (key, value, inputValue = null) => {
    setTempFormState((prev) => ({
      ...prev,
      [key]: value,
      [`${key}Input`]: inputValue !== null ? inputValue : prev[`${key}Input`],
    }));

    if (inputValue !== null) {
      latestInputValue.current = inputValue;
      clearTimeout(debounceTimeout.current);
      debounceTimeout.current = setTimeout(() => {
        fetchUserFilterData({ [`${key}Search`]: latestInputValue.current });
      }, 1000);
    }
  };

  const handleResetFilter = () => {
    const resetFilters = {
      name: null,
      email: null,
      status: null,
      role: null,
      city: null,
    };
    setFormState(resetFilters);
    setUsersData((prevState) => ({
      ...prevState,
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    }));
    const query = qs.stringify(
      {
        ...resetFilters,
        page: 1,
      },
      { skipNull: true, skipEmptyString: true }
    );
    navigate(`/users?${query}`);
    setAnchorEl(null);
  };
  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
    setTempFormState(formState);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleApplyFilter = async () => {
    const query = qs.stringify(
      {
        ...tempFormState,
        page: 1,
      },
      { skipNull: true, skipEmptyString: true }
    );
    setFormState(tempFormState);
    setAppliedFilters(tempFormState);
    navigate(`/users?${query}`);
    // setAppliedFilters({ ...formState });
    // await fetchUsersGridData();
    handleClose();
  };

  const handleRowSelection = (row) => {
    navigate(`/users-details/${row.id}`, {
      state: {
        id: row.id,
      },
    });
  };

  const fetchUsersGridData = useCallback(async () => {
    const payload = {
      name: appliedFilters.name,
      email: appliedFilters.email,
      status: appliedFilters.status,
      role: appliedFilters.role,
      city: appliedFilters.city,
      page: usersData.paginationModel.page + 1,
      pageSize: usersData.paginationModel.pageSize,
    };
    setLoading((prev) => ({
      ...prev,
      grid: true,
    }));
    try {
      const response = await API.post("user/get-user-details", payload);
      const apiData = response?.data?.data;

      setUsersData((prevState) => ({
        ...prevState,
        listData: apiData,
      }));
    } catch (error) {
      console.error("Error fetching Users grid data:", error);
    } finally {
      setLoading((prev) => ({
        ...prev,
        grid: false,
      }));
      setAnchorEl(null);
    }
  }, [
    appliedFilters.name,
    appliedFilters.email,
    appliedFilters.status,
    appliedFilters.role,
    appliedFilters.city,
    usersData.paginationModel.page,
    usersData.paginationModel.pageSize,
  ]);
  useEffect(() => {
    fetchUsersGridData();
  }, [
    // usersData.paginationModel.page,
    // usersData.paginationModel.pageSize,
    // appliedFilters,
    fetchUsersGridData,
  ]);

  const fetchUserFilterData = async (filterParams) => {
    try {
      const response = await API.get("/user/get-user-filter-details", {
        params: filterParams,
      });

      if (response) {
        const apiData = response.data.data;

        setFormConfigurations((prevConfig) =>
          prevConfig.map((config) => {
            if (apiData.length > 0 && apiData[0].hasOwnProperty(config.name)) {
              const newOptions = apiData
                .map((item) => item[config.name])
                .filter((val) => val && val.trim() !== "")
                .map((val) => ({
                  value: val,
                  label: val,
                }));

              const mergedOptions = [
                ...newOptions,
                ...(config.options || []),
              ].reduce((acc, option) => {
                if (!acc.find((o) => o.value === option.value)) {
                  acc.push(option);
                }
                return acc;
              }, []);

              return { ...config, options: mergedOptions };
            }
            return config;
          })
        );
      }
    } catch (error) {
      console.error("Error fetching filter data:", error);
    }
  };

  useEffect(() => {
    const queryParams = qs.parse(location.search);

    const { page = 1, name, email, status, role, city } = queryParams;

    const filtersFromQuery = {
      name: name ? (Array.isArray(name) ? name : [name]) : null,
      email: email ? (Array.isArray(email) ? email : [email]) : null,
      status: status ? (Array.isArray(status) ? status : [status]) : null,
      role: role ? (Array.isArray(role) ? role : [role]) : null,
      city: city ? (Array.isArray(city) ? city : [city]) : null,
    };

    setFormState(filtersFromQuery);
    setAppliedFilters(filtersFromQuery);

    setUsersData((prev) => ({
      ...prev,
      paginationModel: {
        ...prev.paginationModel,
        page: parseInt(page) - 1,
      },
    }));
  }, [location.search]);
  useEffect(() => {
    if (anchorEl) {
      const fieldsToFetch = formConfigurations
        .filter(
          (field) =>
            field.type === "autocomplete-multiple" &&
            !(
              field.options &&
              field.options.length > 0 &&
              field.options.every((opt) => opt.value && opt.label)
            )
        )
        .map((field) => field.name);

      const payload = {};

      fieldsToFetch.forEach((field) => {
        if (formState[field] !== null && formState[field] !== undefined) {
          payload[`${field}Search`] = "";
        }
      });

      if (Object.keys(payload).length > 0) {
        fetchUserFilterData(payload);
      }
    }
  }, [anchorEl, formConfigurations]);

  const debouncedFetchUserFilterData = debounce(fetchUserFilterData, 500);

  const fetchUserData = async () => {
    setLoading((prev) => ({
      ...prev,
      count: true,
    }));
    try {
      const response = await API.post("tiles/get-count", {
        tile_type: "user_count",
      });
      const apiData = response.data.data;

      setUsersData((prevState) => ({
        ...prevState,
        countData: apiData,
      }));
    } catch (error) {
      console.error("Error fetching employer data:", error);
    } finally {
      setLoading((prev) => ({
        ...prev,
        count: false,
      }));
    }
  };
  useEffect(() => {
    fetchUserData();
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: "16px",
        backgroundColor: "#E3F2FD",
        height: "100%",
        boxSizing: "border-box",
        borderRadius: "24px 0 0 0",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: "12px",
          padding: "16px",
          marginBottom: "16px",
          flexShrink: 0,
        }}
      >
        <Typography sx={{ fontSize: "20px", fontWeight: "600" }}>
          Users
        </Typography>

        {loading.count ? (
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: "12px",
              flex: 1,
              textAlign: "center",
              padding: "16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "100px",
            }}
          >
            <LoadingSpinner />
          </Box>
        ) : usersData.countData.length > 0 ? (
          <CountInfo sections={usersData.countData} showHeader={false} />
        ) : (
          <CountInfo sections={[]} showHeader={false} />
        )}
      </Box>
      <Box
        sx={{
          borderRadius: "12px",
          padding: "16px",
          backgroundColor: "white",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "16px",
            flexShrink: 0,
          }}
        >
          <Typography sx={{ fontSize: "18px", fontWeight: 600 }}>
            List of Users
          </Typography>

          <Box sx={{ display: "flex", gap: "12px" }}>
            <Button
              sx={{
                backgroundColor: "#2196F3",
                padding: "6px 10px",
                color: "white",
                display: "flex",
                alignItems: "center",
                borderRadius: "5px",
              }}
              onClick={() => setAddUserDialog(true)}
            >
              <PersonAddIcon sx={{ fontSize: 20, marginRight: "8px" }} />
              <Typography sx={{ fontSize: "14px" }}>ADD USER</Typography>
            </Button>

            <Button
              onClick={(e) => handleOpen(e)}
              sx={{
                backgroundColor: "#2196F3",
                padding: "6px 10px",
                color: "white",
                display: "flex",
                alignItems: "center",
                borderRadius: "5px",
              }}
            >
              <FilterAltOutlinedIcon
                sx={{ fontSize: 20, marginRight: "8px" }}
              />
              <Typography sx={{ fontSize: "14px" }}>FILTER</Typography>
            </Button>
          </Box>
        </Box>
        <Box sx={{ flex: 1, overflow: "hidden" }}>
          <DynamicDataGrid
            rows={usersData?.listData?.userDetails || []}
            showCheckbox={false}
            onRowSelection={handleRowSelection}
            totalRows={usersData?.listData?.totalUsers || 0}
            formatters={formatters}
            paginationModel={usersData?.paginationModel}
            onPaginationModelChange={(paginationModel) => {
              setUsersData((prevState) => ({
                ...prevState,
                paginationModel,
              }));
              navigate(
                `/users?${qs.stringify(
                  {
                    ...formState,
                    page: paginationModel.page + 1,
                  },
                  { skipNull: true, skipEmptyString: true }
                )}`
              );
            }}
            loading={loading.grid}
          />
        </Box>
        <Popover
          anchorReference="anchorE1"
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <Box sx={{ padding: 2, width: 300 }}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Users Filters
            </Typography>
            <Divider sx={{ my: 1 }} />
            {formConfigurations ? (
              <DynamicForm
                formData={formConfigurations}
                debouncedFilterData={debouncedFetchUserFilterData}
                handleChange={handleChange}
                formState={tempFormState}
                filterData={fetchUserFilterData}
              />
            ) : (
              <LoadingSpinner />
            )}
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: 2,
                gap: 1,
              }}
            >
              <Button onClick={handleResetFilter}>Reset</Button>
              <Button variant="contained" onClick={handleApplyFilter}>
                Apply
              </Button>
            </Box>
          </Box>
        </Popover>

        <AddUser open={addUserDialog} onClose={() => setAddUserDialog(false)} />
      </Box>
    </Box>
  );
}
export default Users;
